export default __webpack_public_path__ + "14fdd30d235b470c50157e3bed61c1d9.svg";